import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import moment from 'moment/moment';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatDatetimePickerInputEvent } from '@angular-material-components/datetime-picker';

@Component({
  selector: 'ebo-custom-picker',
  templateUrl: './custom-picker.html'
})
export class CustomPickerComponent implements OnInit {
  @Input() title?: string;
  @Input() pickerValue: FormControl;
  @Input() pickerState?: FormControl;
  @Input() mode: 'date' | 'time' | 'datetime';
  initialValue: string;

  ngOnInit(): void {
    this.initialValue = this.pickerValue.value;

    this.normalizeDateControlValue(this.pickerValue);
    this.pickerValue.valueChanges.subscribe(value => {
      if (value !== this.initialValue && this.pickerState.value !== 1) {
        this.pickerState.setValue(2);
      }
    });
  }

  normalizeDateControlValue(ctrl: FormControl): void {
    const raw = ctrl.value;

    if (!raw || typeof raw !== 'string') return;

    const parsed = moment(raw, 'DD/MM/YYYY', true);
    const isDateOnly = parsed.isValid() && !raw.includes(':') && !raw.includes('T');

    if (isDateOnly) {
      const jsDate = parsed.toDate();
      ctrl.setValue(jsDate, { emitEvent: false });
    }
  }
}
